var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.36842V0H0.612245L0.714286 6.36842L3.06122 8.49123H4.28571L1.73469 5.98246H2.44898L5 8.49123V11H2.44898V8.49123L0 6.36842Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.36842V0H9.5102L9.42857 6.36842L7.55102 8.49123H6.57143L8.61224 5.98246H8.04082L6 8.49123V11H8.04082V8.49123L10 6.36842Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4209 2.37931V0.820485H6.53855V1.58519L5.36207 0.526367L2.4209 3.17343H3.30325V5.52637H5.06796V3.76166H5.65619V5.52637H7.4209V3.17343H8.30325L7.4209 2.37931ZM6.83266 4.93813H6.24443V3.17343H4.47972V4.93813H3.89149V2.64107L5.36207 1.31754L6.83266 2.64107V4.93813Z",
    fill: "white",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77441 2.58531H5.95088C5.95088 2.26178 5.68618 1.99707 5.36265 1.99707C5.03912 1.99707 4.77441 2.26178 4.77441 2.58531Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/type.c46adc256c7f43d19cbea8873fe8016a.svg";
export { ForwardRef as ReactComponent };